module.exports = __webpack_public_path__ + "img/down2.00b6d1a7.png";